@if (!!snapshot()) {
<app-snapshot
  [size]="videoSize()"
  [snapshot]="snapshot()"
  [class.snapshot-loading]="isWaiting() || isAnalyzing()"
  (ready)="snapshotReady($event)"
  (error)="snapshotError($event)"
></app-snapshot>
} @if (isWaiting() || isAnalyzing()) {
<div class="fx-row fx-gap=10 vision-loading">
  <av-spinner size="xs"></av-spinner>
  @if (isWaiting()) {
  <div translate>Acquiring snapshot...</div>
  } @if (isAnalyzing()) {
  <div translate>Analyzing...</div>
  }
</div>
} @if (!!result()) {
<div class="vision-message" [innerHTML]="result() | markdown"></div>
<div class="vision-disclaimer">
  &centerdot; <span translate>Check important info for mistakes</span>
</div>
}
